// Axios
import Axios from "./axios"

export const sendTokenReset = (email) => {
    return new Promise((resolve, reject) => {
        const data = Axios.post(`/user/sendTokenPass/${email}`,     )
        setTimeout(() => resolve(data), 0)
    })
}